module.exports = "\n<div class=\"row\">\n    <label>\n        <i class=\"fa fa-info-circle text-primary\" aria-hidden=\"true\"></i>\n        <span jhiTranslate=\"cadensApp.formation.informations\">Informations</span></label>\n</div>\n\n<div class=\"row bloc-informations\" [innerHTML]=\"information\"></div>\n\n<hr>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/entities/blocks/information/information.component.html
// module id = 407
// module chunks = 0